import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import ModalDelete from "../../../Modal/ModalDelete";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import { AiFillEye } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";

const TableWhatsApp = ({ userID, token, eventID, myEmail: myWhatsApp }) => {
  const [attendeeID, setAttendeeID] = useState(null);
  const [attendEmail, setAttendeeWhatsApp] = useState(null);
  const [smsDetails, setWhatsAppDetails] = useState(null);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const key = ["allWhatsApp", eventID];
  const mutationDelete = useCustomMutation(key);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isSmallMobile = windowWidth < 480;

  const toggleViewWhatsApp = (details) => {
    setWhatsAppDetails(details);
    setIsToggleView(!isToggleView);
  };

  const toggleDeleteWhatsApp = (id, email) => {
    setAttendeeID(id);
    setAttendeeWhatsApp(email);
    setIsToggleDelete(!isToggleDelete);
  };

  const DeleteWhatsApp = () => {
    const Method = "DELETE",
      url = `attendees/${attendeeID}/?eventId=${eventID}&email=${attendEmail}`,
      isJSON = null;
    var raw = null;
    const data = {
      endPoint: url,
      bodyContent: raw,
      Method: Method,
      displayMessage: "WhatsApp Successfully Deleted",
      token: token,
      isJSON: isJSON,
    };
    mutationDelete.mutate(data);
  };

  useEffect(() => {
    if (mutationDelete.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutationDelete.isSuccess]);

  const customStyles = {
    tableWrapper: {
      style: {
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        borderBottomWidth: "2px",
        borderBottomColor: "#e9ecef",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        fontSize: isMobile ? "10px" : "12px",
        fontWeight: "700",
        color: "#495057",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        fontSize: isMobile ? "11px" : "13px",
        color: "#212529",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        minHeight: "60px",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#f8f9fa",
        },
        borderBottomWidth: "1px",
        borderBottomColor: "#e9ecef",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#ffffff",
        borderTopWidth: "1px",
        borderTopColor: "#e9ecef",
        minHeight: "52px",
        fontSize: "13px",
      },
    },
  };

  const columns = [
    {
      name: <span>Audience</span>,
      selector: (row) => row?.audience,
      sortable: true,
      grow: 2,
      style: {
        fontWeight: "600",
        fontSize: isMobile ? "12px" : "14px",
      },
      cell: (row) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingRight: "8px",
          }}
          title={row?.audience}
        >
          {row?.audience || "N/A"}
        </div>
      ),
    },
    {
      name: <span>Message</span>,
      sortable: true,
      grow: 3,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => {
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              paddingRight: "8px",
              color: "#6b7280",
            }}
            title={row?.body}
          >
            {row?.body?.length > 0
              ? `${row?.body?.substring(0, 40)}...`
              : row?.body || "N/A"}
          </div>
        );
      },
    },
    {
      name: <span>Actions</span>,
      cell: (row) => {
        const buttonSize = isMobile ? 32 : 36;
        const iconSize = isMobile ? 14 : 18;
        const gapSize = isMobile ? 4 : 8;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: `${gapSize}px`,
              flexWrap: "nowrap",
            }}
          >
            <button
              onClick={() => toggleViewWhatsApp(row)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#0d6efd",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(13, 110, 253, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="View WhatsApp"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(13, 110, 253, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(13, 110, 253, 0.35)";
              }}
            >
              <AiFillEye size={iconSize} />
            </button>

            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#ffc107",
                color: "#000000",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(255, 193, 7, 0.35)",
                flexShrink: 0,
                padding: 0,
                opacity: 0.6,
                cursor: "not-allowed",
              }}
              title="Edit (Coming Soon)"
              type="button"
              disabled
            >
              <BiEdit size={iconSize} />
            </button>

            <button
              onClick={() => toggleDeleteWhatsApp(row?._id, row?.audience)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#dc3545",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(220, 53, 69, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="Delete WhatsApp"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(220, 53, 69, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(220, 53, 69, 0.35)";
              }}
            >
              <AiFillDelete size={iconSize} />
            </button>
          </div>
        );
      },
      center: true,
      minWidth: isMobile ? "120px" : "150px",
    },
  ];

  const data = myWhatsApp || [];

  return (
    <div style={styles.container}>
      {data.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>💬</div>
          <h4 style={styles.emptyTitle}>No WhatsApp messages found</h4>
          <p style={styles.emptyText}>
            Start by sending your first WhatsApp message
          </p>
        </div>
      ) : (
        <div style={styles.tableWrapper}>
          <DataTable
            columns={columns}
            data={data}
            responsive
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50]}
            customStyles={customStyles}
            highlightOnHover
            noDataComponent={
              <div style={styles.noData}>No records to display</div>
            }
          />
        </div>
      )}

      <ModalDelete
        size="md"
        isOpen={isToggleDelete}
        toggle={() => {
          setIsToggleDelete(false);
        }}
        title="Delete WhatsApp Message"
        body={
          <div style={{ padding: "16px" }}>
            <p style={{ marginBottom: "16px", color: "#6b7280" }}>
              Are you sure you want to delete this WhatsApp message? This
              action cannot be undone.
            </p>
            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => setIsToggleDelete(false)}
                style={{
                  padding: "10px 20px",
                  background: "#f3f4f6",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  cursor: "pointer",
                }}
                type="button"
              >
                Cancel
              </button>
              <button
                onClick={DeleteWhatsApp}
                disabled={mutationDelete?.isLoading}
                style={{
                  padding: "10px 20px",
                  background: "#dc3545",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#ffffff",
                  cursor: mutationDelete?.isLoading ? "not-allowed" : "pointer",
                  opacity: mutationDelete?.isLoading ? 0.7 : 1,
                }}
                type="button"
              >
                {mutationDelete?.isLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        }
      />

      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="WhatsApp Details"
        body={
          <div>
            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: "bold", color: "#6b7280" }}>
                To:{" "}
              </span>
              <span style={{ fontWeight: "600", color: "#111827" }}>
                {smsDetails?.audience}
              </span>
            </div>

            <div
              style={{
                padding: "16px",
                border: "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
                minHeight: "200px",
                fontSize: "14px",
                lineHeight: "1.6",
                color: "#374151",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {smsDetails?.body}
            </div>
          </div>
        }
        toggleSaveChanges={() => toggleViewWhatsApp()}
        directionOffCanvas="end"
        widthOffCanvas={isMobile ? "100%" : 500}
      />

      <style>{`
        @media (max-width: 768px) {
          .whatsapp-table-container {
            padding: 8px !important;
          }
        }

        @media (max-width: 480px) {
          .whatsapp-table-container {
            padding: 4px !important;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    padding: "16px",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    minHeight: "250px",
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  emptyTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: "#212529",
  },
  emptyText: {
    margin: 0,
    fontSize: "14px",
    color: "#6c7280",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "8px",
  },
  noData: {
    padding: "40px 20px",
    textAlign: "center",
    color: "#6c757d",
    fontSize: "14px",
  },
};

export default TableWhatsApp;